<footer [class]="getClass()">
	<payment-preview *ngIf="!hidePaymentIcons" [size]="size" [version]="version" [step]="step"></payment-preview>

	<span *ngIf="footer != null && footer != 'triargos'">{{ 'footer.service' | translate }}</span>
	<span *ngIf="footer == 'triargos'">{{ 'footer.service.poweredby' | translate }}</span>
	<a href="https://www.gls.de/gemeinnuetzige-kunden/zahlungsverkehr/gls-espende/" target="_blank" *ngIf="footer == 'gls'"><img src="/bundles/twinglepublic/donation-app/img/logo-gls-woclaim.svg" alt="Logo mit Link zur Spendeninformationsseite der GLS Bank"></a>
	<a href="http://triargos.de/" target="_blank" *ngIf="footer == 'triargos'"><img src="/bundles/twinglepublic/donation-app/img/Triargos_Logo_web.png" alt="Triargos"></a>

	<div class="impress-wrapper">
		<a
			(click)="showDataprotection()"
			(keydown.enter)="showDataprotection()"
			(keydown.space)="showDataprotection()"
			tabindex="0"
			[attr.role]="privacy_url? 'link' : 'button'"
			[attr.href]="privacy_url? privacy_url : null"
			[attr.target]="privacy_url? '_blank' : null"
		>{{ 'footer.dataprotection' | translate}}</a>
		<a
			(click)="showImpress()"
			(keydown.enter)="showImpress()"
			(keydown.space)="showImpress()"
			tabindex="0"
			[attr.role]="impress_url? 'link' : 'button'"
			[attr.href]="impress_url? impress_url : null"
			[attr.target]="impress_url? '_blank' : null"
			*ngIf="version == 'page'"
		>{{ 'footer.impress' | translate}}</a>
	</div>
</footer>
